import actionTypes from '../constants/action-types';
import registerInterruptionPoint from '../helpers/register-interruption-point';

const interruptionPoint = () => (next) => (action) => {
  if (action.type === actionTypes.REGISTER_INTERRUPTION_POINT) {
    const { actionType, matcher } = action.payload;

    registerInterruptionPoint(actionType, matcher);
  }

  next(action);
};

export default interruptionPoint;
